import axios from '@/plugins/axios';

export const getMaterialInfoPR = async (
  materialId,
  requiredQty,
  { customer, VKORG, VTWEG, VKBUR }
) => {
  const materialData = {
    code: materialId,
    units: requiredQty,
    customer,
    VKORG,
    VTWEG,
    VKBUR,
  };

  const response = await axios.post('get-material-info-pr', materialData);

  return response.data;
};

export const getMaterialInfoKit = async (
  materialId,
  requiredQty,
  { customer, VKORG, VTWEG, VKBUR }
) => {
  const materialData = {
    materialId,
    requiredQty,
    customer,
    VKORG,
    VTWEG,
    VKBUR,
  };

  const response = await axios.post('/kit/get-material', materialData);

  return response.data;
};

export const getClearanceMaterials = async (channel, customer, center) => {
  const response = await axios.get('/clearance-materials', {
    params: {
      channel,
      customer,
      center,
    },
    cachable: true,
  });

  return response.data;
};

export const getClearanceMaterialsCSV = async (channel, customer, center) => {
  const response = await axios.get('/clearance-materials/csv', {
    params: {
      channel,
      customer,
      center,
    },
  });

  return response.data;
};

export const sendByEmailClearanceMaterials = async (
  channel,
  email,
  customer,
  center
) => {
  const response = await axios.post(
    '/clearance-materials/email',
    { email },
    {
      params: {
        channel,
        customer,
        center,
      },
    }
  );

  return response.data;
};
